import React from 'react';
import DownloadIDSRulesForm from '../DownloadIDSRulesForm';

const SecurityPage = () => {

    return (<DownloadIDSRulesForm/>)
}

export default SecurityPage